import React, { useRef } from 'react';
import { Grid, InputLabel, FormControl, Autocomplete, TextField, Button } from '@mui/material';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';

const DropdownWithBtn = ({
    label,
    id,
    options = [],
    value,
    onChange,
    isDesktop,
    getOptionLabel,
    isOptionEqualToValue,
    handleDropdownOpen,
    handleDropdownClose,
    valueFinder,
    handleAddNew, // New prop for handling the "Add New" action
}) => {
    const selectedValue = value == null || value === '' ? null : valueFinder(options, value);

    // Create a ref to manage the focus
    const inputRef = useRef(null);

    const handleOptionChange = (event, newValue) => {
        onChange(newValue);

        // Programmatically remove focus by focusing another element (or blur the current input)
        if (inputRef.current) {
            inputRef.current.blur(); // Removes focus from the dropdown input field
        }
    };

    return (
        <Grid item xs={12} md={6}>
            <Grid container alignItems="center" spacing={1}>
                {label ? <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                    <InputLabel id={id}>{label}:</InputLabel>
                </Grid> : null}
                <Grid item xs>
                    <FormControl fullWidth>
                        <Autocomplete
                            id={id}
                            name={id}
                            options={options}
                            getOptionLabel={getOptionLabel} // Dynamically passed function
                            value={selectedValue} // Dynamically passed function for finding the value
                            onChange={handleOptionChange} // Handle item selection and focus removal
                            onOpen={() => handleDropdownOpen(id)}
                            onClose={() => handleDropdownClose(id)}
                            autoHighlight // Automatically highlights the first option when the dropdown is opened
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select an option"
                                    sx={{
                                        ...inputStyles,
                                        '& .MuiInputBase-root': {
                                            height: '35px', // Set your desired height here
                                        },
                                    }}
                                    inputRef={inputRef} // Assign the ref to the input element
                                />
                            )}
                            isOptionEqualToValue={isOptionEqualToValue} // Dynamically passed function for comparison
                        />
                    </FormControl>
                </Grid>
                {/* Add New Button */}

                {handleAddNew ?
                    <Grid item xs>
                        <Button onClick={handleAddNew} variant="contained" size="small">
                            New
                        </Button>
                    </Grid>
                    : null}
            </Grid>
        </Grid>
    );
};

export default DropdownWithBtn;
